<template>
  <div class="menu">
    <div class="menu_mid clearfix">
      <div class="logo">
        <router-link :to="{name:'index'}">
          <img src="@/assets/images/logo.jpg" alt="新力基金" />
        </router-link>
      </div>
      <div class="tab">
        <ul>
          <li v-for="(item,index) in menuList" :key="index"
            :class="{'active':item.routerName == $route.matched[0].name }">
            <a href="javascript:;" class="menTop" @click="link(item)">{{item.name}}</a>
            <!-- <router-link class="menTop" :to="{name:item.routerName}">{{item.name}}</router-link> -->
            <i class="el-icon-caret-bottom" v-if="item.children.length>0"></i>
            <div class="select">
              <span v-for="(i,k) in item.children" :key="k">
                <a href="javascript:;" class="menBottom" @click="linkb(i)">{{i.name}}</a>
                <!-- <router-link :to="{name:i.routerName,query:{
                  id:i.query
                }}" class="menBottom">{{i.name}}</router-link>-->
              </span>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    name: "menuNav",
    props: {
      pageName: {
        type: String,
        required: false
      }
    },
    data() {
      return {
        menuList: [{
            id: 1,
            routerName: "aboutus",
            name: "关于基金会",
            children: []
          },
          {
            id: 2,
            routerName: "information",
            name: "基金会资讯",
            query: '1',
            children: [{
                id: 13,
                routerName: "information",
                query: '3',
                name: "最新消息"
              },
              {
                id: 12,
                routerName: "information",
                query: '2',
                name: "荣誉奖项"
              },
              {
                id: 11,
                routerName: "information",
                query: '1',
                name: "媒体报道"
              },
              {
                id: 14,
                routerName: "information",
                query: '4',
                name: "信息披露"
              },
              {
                id: 15,
                routerName: "information",
                query: '5',
                name: "志愿者双月刊"
              }
            ]
          },
          {
            id: 3,
            routerName: "foundationProjects",
            query: '0',
            name: "基金会项目",
            children: [{
              id: 11,
              routerName: "foundationProjects",
              query: '1',
              name: "紧急救灾",
            }, {
              id: 13,
              routerName: "foundationProjects",
              query: '3',
              name: "儿童福利",
            }, {
              id: 14,
              routerName: "foundationProjects",
              query: '4',
              name: "边缘救助",
            }, {
              id: 15,
              routerName: "foundationProjects",
              query: '5',
              name: "行业促进",
            }, {
              id: 12,
              routerName: "foundationProjects",
              query: '2',
              name: "新·扶贫计划",
            }]
          },
          {
            id: 4,
            routerName: "activityList",
            name: "志愿者活动",
            children: []
          },
          {
            id: 5,
            routerName: "partnerList",
            name: "合作伙伴",
            children: [
              //    {
              //   id: 12,
              //   routerName: "partnerForm",
              //   name: "合作伙伴申请",
              // }
            ]
          }
        ]
      };
    },
    created() {
      // this.getfetch();
    },
    methods: {
      getfetch() {
        console.log("路由", this.$route);
      },
      link(item) {
        this.$router.push({
          name: item.routerName,
          // params: {
          //   id: item.query
          // }
        });
      },
      linkb(item) {
        console.log('item', item)
        this.$router.push({
          name: item.routerName,
          query: {
            id: item.query
          }
        });
      }
    }
  };

</script>
<style lang="scss" scoped>
  .menu {
    width: 100%;
    height: 70px;

    .menu_mid {
      width: 1200px;
      height: 70px;
      margin: 0 auto;

      .logo {
        margin-top: 15px;
        float: left;
      }

      .tab {
        margin-top: 15px;
        float: right;

        ul {
          li {
            width: 150px;
            margin-left: 10px;
            height: 40px;
            line-height: 40px;
            border-radius: 5px;
            text-align: center;
            float: left;
            // padding: 20px 15px;
            font-size: 20px;
            position: relative;

            a {
              width: 150px;
              display: block;
            }

            &.active {
              background: #a3c31d;

              a,
              i {
                color: #fff;
              }

              .el-icon-caret-bottom {
                &:before {
                  content: '' !important;
                  background-position: -16px 0;
                }
              }
            }

            .el-icon-caret-bottom {
              position: absolute;
              right: 3px;
              top: 10px;

              &:before {
                content: '' !important;
                background: url('../assets/images/icon-drop.png') 0 0 no-repeat;
                background-size: 32px 17px;
                display: block;
                width: 16px;
                height: 17px;
                position: relative;
                right: 3px;
                top: 2px;
              }
            }

            &:hover {
              background: #a3c31d;

              .el-icon-caret-bottom {
                &:before {
                  content: '' !important;
                  background-position: -16px 0;
                }
              }

              .menTop {
                color: #fff;
              }

              .select {
                z-index: 999;
                opacity: 1;
                -webkit-transform: scale(1, 1);
              }

              i {
                color: #fff;
              }
            }

            .select {
              width: 150px;
              border-radius: 5px;
              opacity: 0;
              position: absolute;
              top: 45px;
              background: #fff;
              color: #333;
              box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
              z-index: -1;
              transition: ease-in 0.3s;
              transform-origin: 50% 0 0;
              -webkit-transform: scale(1, 0);
              overflow: hidden;

              span {
                display: inline-block;
                height: 40px;
                line-height: 40px;

                .menBottom {
                  width: 150px;
                  height: 40px;
                  color: #333;

                  &:hover {
                    width: 150px;
                    height: 40px;
                    background: #a3c31d;
                    color: #fff;
                    display: block;

                    &.menBottom {
                      color: #fff;
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Menu.vue